import { Component, ElementRef, forwardRef, ViewChild } from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS,
  Validator,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';

@Component({
  selector: 'app-qasr-plate',
  templateUrl: './qasr-plate.component.html',
  styleUrls: ['./qasr-plate.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => QasrPlateComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => QasrPlateComponent),
      multi: true,
    },
  ],
})
export class QasrPlateComponent implements ControlValueAccessor, Validator {
  @ViewChild('part2Input') part2Input!: ElementRef<HTMLInputElement>;

  part1: string = ''; // 5 digits
  part2: string = ''; // 2 digits

  onChange: any = () => {};
  onTouch: any = () => {};

  // Convert English numbers to Persian
  toPersian(num: string): string {
    if (!num) return '';
    const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    return num.toString().replace(/\d/g, (x) => persianDigits[parseInt(x)]);
  }

  // Convert Persian numbers to English (for internal logic)
  toEnglish(num: string): string {
    if (!num) return '';
    const persianDigits = [
      /۰/g,
      /۱/g,
      /۲/g,
      /۳/g,
      /۴/g,
      /۵/g,
      /۶/g,
      /۷/g,
      /۸/g,
      /۹/g,
    ];
    let result = num.toString();
    for (let i = 0; i < 10; i++) {
      result = result.replace(persianDigits[i], i.toString());
    }
    return result.replace(/\D/g, ''); // Keep only digits
  }

  onPart1Input(event: any) {
    let value = this.toEnglish(event.target.value);
    if (value.length > 5) value = value.substring(0, 5);
    this.part1 = value;

    // Auto focus to next input
    if (this.part1.length === 5) {
      this.part2Input.nativeElement.focus();
    }
    this.updateValue();
  }

  onPart2Input(event: any) {
    let value = this.toEnglish(event.target.value);
    if (value.length > 2) value = value.substring(0, 2);
    this.part2 = value;
    this.updateValue();
  }

  updateValue() {
    const p1 = this.part1.substring(0, 2);
    const p2 = this.part1.substring(2, 5);
    const p3 = this.part2;

    const fullValue = `${p1} ق ${p2} | ${p3}`;

    this.onChange(fullValue);
    this.onTouch();
  }

  // ControlValueAccessor methods
  writeValue(value: string): void {
    if (value) {
      const digits = value.replace(/\D/g, '');

      this.part1 = digits.substring(0, 5);
      this.part2 = digits.substring(5, 7);
    } else {
      this.part1 = '';
      this.part2 = '';
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  // Validator method
  validate(control: AbstractControl): ValidationErrors | null {
    return null;

    if (!this.part1 || !this.part2) return { required: true };
    if (this.part1.length !== 5 || this.part2.length !== 2)
      return { invalidLength: true };
    return null;
  }
}
